import React, { useMemo, useState, useEffect } from "react";
import {
    Card, CardBody, CardHeader, Badge, Button, Progress,
    ListGroup, ListGroupItem, Row, Col
} from "reactstrap";
import { FaCheck, FaTimes, FaPaperclip } from "react-icons/fa";
// import { use } from "react";

export default function DocumentChecklist({ supportTypeId, docs, onConfirm, setSelectDocs }) {
    const DOCS_BY_TYPE = {
        1: [ //4
            { id: "1", label: "ตรวจสอบข้อมูลการจดทะเบียนนิติบุคคลพร้อมัวัตถุประสงค์ (กรณีเป็นศูนย์ทดสอบฯ ที่จัดตั้งโดยนิติบุคคล)" },
            { id: "2", label: "ตรวจสอบข้อมูลผู้มีอำนาจ (กรณีเป็นศูนย์ทดสอบฯ ที่จัดตั้งโดยบุคคลธรรมดา เช่น คำสั่งแต่งตั้งผู้อำนวยการ เลขบัตรประชาชน)" },
            { id: "3", label: "ตรวจสอบใบอนุญาตดำเนินการทดสอบมาตรฐานฝีมือแรงงานแห่งชาติ" },
        ],
        2: [ //5
            { id: "1", label: "ตรวจสอบข้อมูลการจดทะเบียนนิติบุคคลพร้อมัวัตถุประสงค์ (กรณีเป็นศูนย์ทดสอบฯ ที่จัดตั้งโดยนิติบุคคล)" },
            { id: "2", label: "ตรวจสอบข้อมูลผู้มีอำนาจ (กรณีเป็นศูนย์ทดสอบฯ ที่จัดตั้งโดยบุคคลธรรมดา เช่น คำสั่งแต่งตั้งผู้อำนวยการ เลขบัตรประชาชน)" },
            { id: "3", label: "ตรวจสอบใบอนุญาตดำเนินการทดสอบมาตรฐานฝีมือแรงงานแห่งชาติ" },
        ],
        3: [ //11
            { id: "1", label: "ตรวจสอบข้อมูลการจดทะเบียนนิติบุคคลพร้อมัวัตถุประสงค์ (กรณีเป็นศูนย์ทดสอบฯ ที่จัดตั้งโดยนิติบุคคล)" },
            { id: "2", label: "ตรวจสอบข้อมูลผู้มีอำนาจ (กรณีเป็นศูนย์ทดสอบฯ ที่จัดตั้งโดยบุคคลธรรมดา เช่น คำสั่งแต่งตั้งผู้อำนวยการ เลขบัตรประชาชน)" },
            { id: "3", label: "ตรวจสอบใบอนุญาตดำเนินการทดสอบมาตรฐานฝีมือแรงงานแห่งชาติ" },
            { id: "4", label: "ตรวจสอบใบเสร็จรับเงินหรือใบเสร็จอิเล็กทรอนิกส์ที่ส่งเงินค่าทดสอบเข้ากองทุนพัฒนาฝีมือแรงงาน" },
        ],
        4: [ //6
            { id: "1", label: "แบบแสดงการส่งเงินสมทบกองทุนพัฒนาฝีมือแรงงาน ในระบบ PRB e-Service ใบเสร็จรับเงินหรือใบเสร็จรับเงินอิเล็กทรอนิกส์ (แล้วแต่กรณี) ตามข้อ 2" },
            { id: "2", label: "แบบแสดงการส่งเงินสมทบกองทุนพัฒนาฝีมือแรงงาน ตามข้อ 3 ในระบบ PRB e-Service" },

        ],
        5: [ //7
            { id: "1", label: "ตรวจสอบใบอนุญาตดำเนินการทดสอบมาตรฐานฝีมือแรงงานแห่งชาติ" },
        ],
        6: [ //8
            { id: "1", label: "ตรวจสอบข้อมูลการจดทะเบียนนิติบุคคลพร้อมวัตถุประสงค์" },
            { id: "2", label: "ตรวจสอบหนังสือรับรองมาตรฐานฝีมือแรงงานตามมาตรา 26 (แบบรมฐ.2)" },

        ],
        7: [ //9
            { id: "1", label: "ตรวจสอบข้อมูลการจดทะเบียนนิติบุคคลพร้อมวัตถุประสงค์" },
            { id: "2", label: "ตรวจสอบหนังสือรับรองว่าเป็นผู้่ผ่านการทดสอบมาตรฐานฝีมือแรงงานแห่งชาติของลูกจ้าง" },

        ],
        8: [ //10
            { id: "1", label: "ตรวจสอบข้อมูลการจดทะเบียนนิติบุคคลพร้อมวัตถุประสงค์" },
            // { id: "2", label: "ตรวจสอบหนังสือรับรองว่าเป็นผู้่ผ่านการทดสอบมาตรฐานฝีมือแรงงานแห่งชาติของลูกจ้าง" },

        ],
        9: [ //11
            { id: "1", label: "ตรวจสอบหนังสือรับรองการเป็นศูนย์ประเมินความรู้ความสามารถ ตามมาตรา 26/4 (2) (แบบ คร.6)" },
            { id: "2", label: "ตรวจสอบใบเสร็จรับเงินหรือใบเสร็จอิเล็กทรอนิกส์ที่ส่งเงินค่าธรรมเนียมเข้ากองทุน" },

        ],
    };

    // fallback เริ่มต้นถ้าไม่ทราบประเภท
    const DEFAULT_DOCS = [
        { id: "other", label: "เอกสารอื่น ๆ (ถ้ามี)" },
    ];
    // เลือกรายการเอกสารจาก docs ที่ส่งเข้ามา หรือจาก mapping ตาม supportTypeId
    const effectiveDocs = useMemo(() => {
        if (Array.isArray(docs) && docs.length > 0) return docs;
        const key = supportTypeId != null ? String(supportTypeId) : undefined;
        return DOCS_BY_TYPE[key] || DOCS_BY_TYPE[supportTypeId] || DOCS_BY_TYPE[Number(supportTypeId)] || DEFAULT_DOCS;
    }, [docs, supportTypeId]);

    const [checked, setChecked] = useState(() =>
        Object.fromEntries(effectiveDocs.map(d => [d.id, false]))
    );

    // เพิ่ม useEffect สำหรับ sync ค่า checked -> setSelectDocs
    useEffect(() => {
        if (typeof setSelectDocs === "function") {
            const selectedIds = Object.entries(checked)
                .filter(([_, value]) => value)   // เอาเฉพาะ true
                .map(([id]) => id);              // เก็บเฉพาะ id
            setSelectDocs(selectedIds);
        }
    }, [checked, setSelectDocs]);

    console.log("checked", checked);

    // รีเซ็ตสถานะเมื่อรายการเอกสารเปลี่ยน (เช่น เมื่อ supportTypeId เปลี่ยนหลังโหลดจาก API)
    useEffect(() => {
        setChecked(Object.fromEntries(effectiveDocs.map(d => [d.id, false])));
    }, [effectiveDocs]);

    // คำนวณจาก "ติ๊กแล้ว / ทั้งหมด"
    const totals = useMemo(() => {
        const totalCount = effectiveDocs.length;
        const checkedCount = effectiveDocs.filter(d => checked[d.id]).length;
        const allChecked = totalCount > 0 && checkedCount === totalCount;
        const percent = Math.round((checkedCount / Math.max(totalCount, 1)) * 100);
        return { totalCount, checkedCount, allChecked, percent };
    }, [effectiveDocs, checked]);

    const toggleOne = (id) => {
        setChecked(prev => ({ ...prev, [id]: !prev[id] }));
    };

    const checkAll = (value) => {
        const next = {};
        effectiveDocs.forEach(d => (next[d.id] = value));
        setChecked(next);
    };

    const handleConfirm = () => {
        onConfirm?.(checked);
    };

    return (
        <>
            <Card className="shadow-sm border-0 rounded-4">
                <CardHeader className="bg-white border-0 d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center gap-2">

                        <Badge color={totals.allChecked ? "success" : "secondary"}>
                            {totals.checkedCount}/{totals.totalCount}
                        </Badge>
                    </div>
                    <div className="d-flex gap-2">
                        <Button size="sm" outline color="secondary" onClick={() => checkAll(false)}>
                            <FaTimes className="me-1" /> ยกเลิกทั้งหมด
                        </Button>
                        <Button size="sm" color="primary" onClick={() => checkAll(true)}>
                            <FaCheck className="me-1" /> ติ๊กครบทั้งหมด
                        </Button>
                    </div>
                </CardHeader>

                <CardBody>
                    <Progress value={totals.percent} className="mb-2" />
                    <small className="text-muted d-block mb-3">
                        {totals.checkedCount} จาก {totals.totalCount} รายการ ({totals.percent}%)
                    </small>

                    <ListGroup flush>
                        {effectiveDocs.map((doc) => {
                            const isOn = !!checked[doc.id];
                            return (
                                <ListGroupItem
                                    key={doc.id}
                                    className="d-flex align-items-center justify-content-between py-3 px-3 rounded-3 checklist-item"
                                >
                                    <div className="d-flex align-items-center gap-3">
                                        <button
                                            type="button"
                                            className={`checkbox-pill ${isOn ? "on" : ""}`}
                                            aria-pressed={isOn}
                                            aria-label={`toggle ${doc.label}`}
                                            onClick={() => toggleOne(doc.id)}
                                        >
                                            {isOn ? <FaCheck /> : <FaPaperclip />}
                                        </button>

                                        <div className="fw-semibold">{doc.label}</div>
                                    </div>
                                </ListGroupItem>
                            );
                        })}
                    </ListGroup>
                </CardBody>

                {/* สไตล์เฉพาะปุ่มเช็ก */}
                <style>{`
           .checkbox-pill {
             width: 42px;
             height: 42px;
             border-radius: 999px;
             border: 2px solid #dee2e6;
             background: #fff;
             display: inline-flex;
             align-items: center;
             justify-content: center;
             font-size: 1rem;
             transition: all .2s ease;
           }
           .checkbox-pill:hover {
             transform: translateY(-1px);
             box-shadow: 0 4px 14px rgba(0,0,0,.08);
           }
           .checkbox-pill.on {
             background: #198754;
             border-color: #198754;
             color: #fff;
           }
           .checklist-item {
             background: #fff;
             border: 1px solid #f1f3f5;
             margin-bottom: .5rem;
           }
           .checklist-item:last-child {
             margin-bottom: 0;
           }
         `}</style>
            </Card>
        </>

    );
}
